"use client"
import React from "react";
import { connect } from "react-redux";
import { Breadcrumb } from "semantic-ui-react";


import ToggleDisplay from "../../common/components/ToggleDisplay"

import { selectCurrentTab2 } from "../tabs/tabsSelectors2";
import { selectTab2 } from "./tabsActions2";

const mapState = (state) => {
    const currentTab2 = selectCurrentTab2(state);

    return { currentTab2 };
}

const actions = { onTabClick2: selectTab2 };

export const BreadcrumbBar = (props) => {
    const { tabs2, currentTab2, onTabClick2, onAfterDeleteTab, onSelectedFromMenu, maxTab, ...otherProps } = props;

    const { innerWidth, innerHeight } = window;

    let _maxTab = 5;
    _maxTab = maxTab;
    if (_maxTab === undefined) {
        _maxTab = innerWidth > 991 ? 4 : 2;
    };

    console.log("tabs2, ", tabs2.filter((tabInfo, index) => index <= _maxTab));
    const tabItems = tabs2.filter((tabInfo, index) => index <= _maxTab).map((tabInfo, index, array) => {
        const { name, label, level } = tabInfo;

        return (
            <React.Fragment key={"fragment_" + name}>
                <Breadcrumb.Divider icon='right chevron' />
                <Breadcrumb.Section link
                    key={name}
                    name={name}
                    label={label}
                    level={level}
                    active={currentTab2 === name}
                    onClick={(e) => {
                        let campoProps = Object.keys(e.target).find(x => x.includes("__reactProps"));
                        onTabClick2(e.target[campoProps].name);
                    }}
                    indexsection={index}>{label}</Breadcrumb.Section>
            </React.Fragment>
        )


    });

    const tabPanels2 = tabs2.map(tabInfo => {
        const { name, codMenu, selectedTipoGenerica, level, component: TabComponent } = tabInfo;
        const addSubTabMenu = props.addSubTabMenu;

        return (
            <ToggleDisplay show={name === currentTab2} key={name}  >
                <TabComponent codMenu={codMenu} selectedTipoGenerica={selectedTipoGenerica} level={level} style={{ "min-heigh": 200 }} addSubTabMenu={addSubTabMenu} />
            </ToggleDisplay>
        )
    })

    return (
        <div className="layout-main">
            <Breadcrumb key={"BreadcrumbBar2"}>
                {tabItems}
            </Breadcrumb>
            {tabPanels2}
        </div>
    )
}

export default connect(mapState, actions)(BreadcrumbBar);
